import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { usePermissions } from "../contexts/PermissionsContext";
import Loader from "./Loader";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const ProtectedComponent = ({ component, ...componentProps }) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const currentPath = useLocation().pathname;
  // Memoize by component reference — withAuthenticationRequired returns a new function on
  // every call, so calling it in the render body causes React to see a new component type
  // each render, unmounting and remounting the page (and losing all its state).
  const Component = React.useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => <Loader />,
      }),
    [component] // currentPath intentionally omitted — only needed for auth redirect, not memoization
  );

  // Pages gate controls on the permission map, so none of them render before
  // it has arrived.
  const { permissionsLoading } = usePermissions();

  if (!isAuthenticated && !isLoading) {
    sessionStorage.setItem("redirectPath", currentPath);
    return <Navigate to="/" state={{ from: currentPath }} replace />;
  }

  if (isLoading || permissionsLoading) {
    return <Loader />;
  }

  return <Component {...componentProps} />;
};

export default ProtectedComponent;
